import React from 'react';
import styles from './styles.module.scss';

const Button = ({
  variant = 'primary',
  onClick,
  disabled = false,
  loading = false,
  children,
  type = 'button',
  className = ''
}) => {
  return (
    <button
      type={type}
      className={`${styles.button} ${styles[variant]} ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading && <span className={styles.spinner} />}
      {children}
    </button>
  );
};

export default Button;